import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Cookie, X } from "lucide-react";

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) {
      // Small delay for better UX
      const timer = setTimeout(() => setShowBanner(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookie_consent", "accepted");
    setShowBanner(false);
    // Enable Google Analytics if it was disabled
    if (window.gtag) {
      window.gtag("consent", "update", {
        analytics_storage: "granted",
      });
    }
  };

  const rejectCookies = () => {
    localStorage.setItem("cookie_consent", "rejected");
    setShowBanner(false);
    // Disable Google Analytics
    if (window.gtag) {
      window.gtag("consent", "update", {
        analytics_storage: "denied",
      });
    }
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-slide-up">
      <div className="max-w-4xl mx-auto">
        <div className="bg-card border border-border rounded-2xl shadow-elevated p-4 md:p-6">
          <div className="flex flex-col md:flex-row md:items-center gap-4">
            {/* Icon and Text */}
            <div className="flex items-start gap-3 flex-1">
              <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                <Cookie className="w-5 h-5 text-primary" />
              </div>
              <div>
                <h3 className="font-semibold text-foreground mb-1">
                  Utilizziamo i cookie 🍪
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  Questo sito utilizza cookie tecnici e di analisi (Google Analytics) per migliorare la tua esperienza di navigazione. 
                  I cookie di analisi ci aiutano a capire come i visitatori interagiscono con il sito.
                </p>
              </div>
            </div>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row gap-2 md:flex-shrink-0">
              <Button
                variant="outline"
                onClick={rejectCookies}
                className="rounded-xl text-sm"
              >
                Solo necessari
              </Button>
              <Button
                onClick={acceptCookies}
                className="rounded-xl text-sm btn-subtle"
              >
                Accetta tutti
              </Button>
            </div>
          </div>

          {/* Privacy Link */}
          <div className="mt-3 pt-3 border-t border-border">
            <p className="text-xs text-muted-foreground">
              Per maggiori informazioni, consulta la nostra{" "}
              <a href="/privacy" className="text-primary hover:underline">
                Privacy Policy
              </a>
              . Puoi modificare le tue preferenze in qualsiasi momento.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
